;(function () {
  'use strict'

  angular
    .module('contrast.tutorial')
    .controller('TutorialModalCtrl', TutorialModalCtrl)

  function TutorialModalCtrl($scope, $uibModalInstance) {
    'ngInject'

    angular.extend($scope, {
      cancel: cancel
    })

    function cancel() {
      $uibModalInstance.dismiss('cancel')
    }
  }
})()
